import { Text } from 'bold-ui'

interface ProfissionalListLabelProps {
  nome?: string
  nomeSocial?: string
  nomeCivil?: string
  cbo?: string
  ineEquipe?: string
  nomeEquipe?: string
}

export const ProfissionalListLabel = (props: Readonly<ProfissionalListLabelProps>) => {
  const { nome, nomeSocial, nomeCivil, cbo, ineEquipe, nomeEquipe } = props

  return (
    <Text>
      {nome}
      {nomeSocial && ' (Nome social)'}
      {cbo && ` | ${cbo.titleCase()}`}
      {ineEquipe ? ` | ${nomeEquipe} - ${ineEquipe}` : ' | Sem equipe'}
      {nomeSocial && ` | Nome civil - ${nomeCivil}`}
    </Text>
  )
}
